import axios from "axios"

export default {
    namespaced: true,

    state: {
        inspirations: []
    },
    mutations: {
        setInspirations(state, array){
            state.inspirations = array
        }
    },
    actions: {
        fetchData(context){
            axios({
                method: "POST",
                data: {
                    query: `{
                        inspirations: entries(section: "inspirations"){
                            id,
                            title,
                            slug
                            ... on inspirations_inspirations_Entry {
                                lead,
                                image {
                                    id,
                                    url
                                },
                            }
                        }
                    }`
                }
            }).then(function(res){
                context.commit('setInspirations', res.data.data.inspirations)
            })
        }
    },
    getters: {}
}
